export default "__VITE_ASSET__CukatnlU__"